import { createApp } from 'vue'
import App from './App.vue'
import './assets/global.css'

// Updated: 2026-02-13
const app = createApp(App)
app.mount('#vue-app')
